export function tagEvent(name, getOptions) {
  try {
    ll('tagEvent', `web__${name}`, getOptions());
  } catch (e) {
    window.console.error(e);
  }
}


// WEBPACK FOOTER //
// ./src/js/util/tracking/localyticsHelper.js